import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7a919ab4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "drawer-content" }
const _hoisted_2 = { style: {"display":"flex","justify-content":"space-between","align-items":"center","flex-wrap":"wrap","gap":"10px"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-search" }, null, -1))
const _hoisted_4 = { class: "selection-bar cm-ui-mb15" }
const _hoisted_5 = { class: "pagination-select-count" }
const _hoisted_6 = { class: "dialog-footer" }

import { ref, reactive, computed, watch, nextTick } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import CmTable from '@/components/cmTable/index.vue'
import { ClientInfo, InstalledDetailService, QueryParams } from './installed-detail.service'
import { formatDuration, formatTimeStamp } from '@/utils/time'
import { useParseTime } from '@/hooks'
import dayjs from 'dayjs'
import { resolveInstalledDetailDateRange } from '@/views/dashboard/manage/genuine-software-usage/_utils/installed-detail-date-range'
import BtnIcon from '@/views/dashboard/_components/btn-icon/btn-icon.vue'
import { ElMessage } from 'element-plus'
import { TableOpt } from '@/components/cmTable/types'
import { computerInfoCols } from '@/views/dashboard/data-safe/ransomware-protection/types/ransomware-incident'
import ExportDropdown from '@/views/dashboard/_components/export-dropdown/export-dropdown.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'installed-detail',
  props: {
    groupId: {},
    softwareKey: {},
    softwareId: {},
    softwareName: {},
    date: {},
    hasPermission: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props

const hasPermission = computed(() => props.hasPermission)

const injector = useReflectiveInjector([InstalledDetailService])
const service = injector.get(InstalledDetailService)

const tableRef = ref<any>()
const { refreshList } = useCmTableListRefresh(tableRef)
const selectedIds = ref<string[]>([])
const selectedRows = ref<ClientInfo[]>([])

const data = reactive({
  uninstallType: 0 as 0 | 1,
  uninstallDialogVisible: false
})

const totalCount = computed(() => tableRef.value?.total ?? 0)
const tableData = computed(() => tableRef.value?.data ?? [])

const { t, locale } = useI18n()

const resolvedDateRange = computed(() => resolveInstalledDetailDateRange(props.date))

const resolvedStartEndSec = computed(() => {
  const [a, b] = resolvedDateRange.value
  return useParseTime([dayjs(a).format('YYYY-MM-DD'), dayjs(b).format('YYYY-MM-DD')])
})

const form = reactive<Partial<QueryParams>>({
  group_id: props.groupId ?? -1,
  key_word: '',
  soft_id: props.softwareId,
  soft_name: props.softwareName,
  start_time: undefined,
  end_time: undefined,
  asc: false,
  sort: 'use_soft_count',
  authenticsoft_flag: 0,
  useMemory: false,
  page: 1,
  limit: 20,
})

function syncFormFromProps () {
  const [st, et] = resolvedStartEndSec.value
  form.group_id = props.groupId ?? -1
  form.soft_id = props.softwareId
  form.soft_name = props.softwareName
  form.start_time = st != null ? st : undefined
  form.end_time = et != null ? et : undefined
}

watch(
  () => [props.groupId, props.softwareId, props.softwareName, props.date],
  () => syncFormFromProps(),
  { deep: true, immediate: true }
)

const pageOption = { pageNumName: 'page', pageSizeName: 'limit' }

const tableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
  selection: true,
  selectColumnOpt: { width: 50 },
  columns: [
   ...computerInfoCols(false,false,t,{mac: false}),
    { prop: 'soft_version', label: t('genuineSoftwareUsageColumns.version'), columnOpt: { minWidth: 120 } },
    { prop: 'install_time', label: t('genuineSoftwareUsageColumns.installTime'), columnOpt: { minWidth: 168, sortable: 'custom' }, formatter: (_row: any, value: number) => formatTimeStamp(value, 'YYYY-MM-DD HH:mm') || '--' },
    { prop: 'use_soft_count', label: t('genuineSoftwareUsageColumns.avgUseCount'), columnOpt: { minWidth: 140, sortable: 'custom' } },
    { prop: 'duration', label: t('genuineSoftwareUsageColumns.avgUseDuration'), columnOpt: { minWidth: 140, sortable: 'custom' } },
    { prop: 'last_active_time', label: t('genuineSoftwareUsageColumns.lastActiveTime'), columnOpt: { minWidth: 168, sortable: 'custom' }, formatter: (_row: ClientInfo, value: unknown) => formatLastActiveValue(value) }
  ],
  rowKey: 'device_id',
  showActionBar: false,
  showSearch: false,
  showRightToolbar: false,
  path: 'list',
  totalPath: 'total',
  usePagination: false,
  disableScrollLoad: false,
  scrollLoadThreshold: 10,
  scrollLoadDelay: 100,
  height: '100%'
  }
})

const tableActOpt = { columnOpt: { width: 0 }, actionButtons: () => [] }

function getListApi(params: any) {
  if (!hasPermission.value) {
    return Promise.resolve({ list: [], total: 0 })
  }
  const raw = params ?? {}
  const p: Partial<QueryParams> = {
    ...form,
    page: raw.page ?? form.page ?? 1,
    limit: raw.limit ?? form.limit ?? 20,
    sort: raw.sort ?? form.sort ?? 'use_soft_count',
    asc: raw.asc ?? form.asc ?? false
  }
  return service.getListByServer(p)
}

function formatLastActiveValue(v: unknown) {
  if (v == null || v === '') return '--'
  if (typeof v === 'number') {
    return formatTimeStamp(String(v), 'YYYY-MM-DD HH:mm') || '--'
  }
  if (typeof v === 'string' && /^\d+$/.test(v.trim())) {
    return formatTimeStamp(v, 'YYYY-MM-DD HH:mm') || '--'
  }
  return String(v)
}

function handleSearch() {
  void refreshList()
}

function handleSelectionChange(selection: ClientInfo[]) {
  selectedRows.value = selection
  selectedIds.value = selection.map(r => r.device_id)
}

function toggleSelectByMemory() {
  form.useMemory = !form.useMemory
  if (!form.useMemory) {
    selectedRows.value = []
    selectedIds.value = []
    tableRef.value?.tableRef?.clearSelection?.()
  }
  void refreshList()
}

function togglePageSelect() {
  const dataList = tableData.value as ClientInfo[]
  const allSelected = dataList.every((r: any) => selectedIds.value.includes(r.device_id))
  if (allSelected) {
    const newIds = selectedIds.value.filter(id => !dataList.some((r: any) => r.device_id === id))
    selectedIds.value = newIds
    selectedRows.value = selectedRows.value.filter(r => !dataList.some((d: any) => d.device_id === r.device_id))
  } else {
    const toAdd = dataList.filter((r: any) => !selectedIds.value.includes(r.device_id))
    toAdd.forEach((r: any) => {
      if (!selectedIds.value.includes(r.device_id)) {
        selectedIds.value = [...selectedIds.value, r.device_id]
        selectedRows.value = [...selectedRows.value, r]
      }
    })
  }
  nextTick(() => nextTickSyncSelection())
}

function nextTickSyncSelection() {
  const ref = tableRef.value?.tableRef
  if (!ref || !ref.toggleRowSelection) return
  const dataList = tableData.value as ClientInfo[]
  dataList.forEach((row: any) => {
    ref.toggleRowSelection(row, selectedIds.value.includes(row.device_id))
  })
}

function selectCancel() {
  selectedRows.value = []
  selectedIds.value = []
  tableRef.value?.tableRef?.clearSelection?.()
}

function showUninstallDialog() {
  if (!hasPermission.value) return
  data.uninstallDialogVisible = true
}

function resetRadio() {
  data.uninstallType = 0
  data.uninstallDialogVisible = false
}

function uninstall() {
  if (!hasPermission.value) return
  data.uninstallDialogVisible = false
  const ids = selectedIds.value
  if (ids.length === 0) return
  const soft_hash_key = props.softwareKey
  service.uninstallSoftware({
    execute_type: 0,
    uninstall_list: ids.map((device_id) => ({ device_id, soft_hash_key })),
    uninstall_type: data.uninstallType,
    soft_name: props.softwareName
  }).then(() => {
    ElMessage.success(t('genuineSoftwareUsage.uninstallSuccessTerminals', { count: ids.length }))
    selectCancel()
    void refreshList()
  }).catch(() => {
    ElMessage.error(t('genuineSoftwareUsage.uninstallFailedTip'))
  })
}

function download(type: 0 | 1) {
  if (!hasPermission.value) return
  const [st, et] = resolvedStartEndSec.value
  const q: QueryParams = {
    group_id: props.groupId ?? -1,
    limit: 20,
    page: 1,
    key_word: form.key_word || '',
    soft_id: props.softwareId ?? undefined,
    soft_name: props.softwareName ?? '',
    useMemory: false,
    start_time: st != null ? String(st) : undefined,
    end_time: et != null ? String(et) : undefined,
    asc: false,
    sort: 'use_soft_count',
    authenticsoft_flag: 0
  }
  service.download(type, q, t('genuineSoftwareUsage.exportPrefixSoftwareDetail') + t('softwareManage.installedSoftwareTitle', { name: props.softwareName || '' }))
}

watch(() => [props.softwareId, props.date], () => {
  void refreshList()
}, { deep: true })

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_BlueTipsIcon = _resolveComponent("BlueTipsIcon")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CmTable, {
      ref_key: "tableRef",
      ref: tableRef,
      "table-opt": tableOpt.value,
      "table-act-opt": tableActOpt,
      api: getListApi,
      modelValue: form,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form) = $event)),
      "page-option": pageOption,
      "has-permission": hasPermission.value,
      onChangeSelected: handleSelectionChange
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_space, { size: 10 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                disabled: selectedRows.value.length === 0 || !hasPermission.value,
                type: "primary",
                size: "small",
                onClick: showUninstallDialog
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('genuineSoftwareUsage.uninstall')), 1)
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(ExportDropdown, {
                "has-permission": hasPermission.value,
                onExport: download
              }, null, 8, ["has-permission"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_input, {
            size: "small",
            disabled: !hasPermission.value,
            modelValue: form.key_word,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.key_word) = $event)),
            placeholder: _ctx.$t('genuineSoftwareUsage.searchPlaceholderInstallDetail'),
            clearable: "",
            onChange: handleSearch,
            style: {"width":"200px"}
          }, {
            suffix: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["disabled", "modelValue", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_BlueTipsIcon, { class: "cm-ui-ml15 cm-ui-mr10" }),
          _createElementVNode("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.$t('genuineSoftwareUsage.selectionPrefix')) + " ", 1),
            _createElementVNode("a", {
              onClick: toggleSelectByMemory,
              class: _normalizeClass(form.useMemory ? 'req-default' : 'req-primary')
            }, _toDisplayString(selectedRows.value.length), 3),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('genuineSoftwareUsage.selectionTerminalSuffix')), 1)
          ]),
          _createVNode(_component_el_button, {
            class: "pagination-select-btn",
            type: "text",
            disabled: tableData.value.length === 0,
            onClick: togglePageSelect
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(tableData.value.every((r) => selectedIds.value.includes(r.device_id)) ? _ctx.$t('genuineSoftwareUsage.selectPageInvert') : _ctx.$t('genuineSoftwareUsage.selectPageAll')), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            class: "pagination-select-btn",
            type: "text",
            disabled: selectedRows.value.length === 0,
            onClick: selectCancel
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('cmtable.clearSelection')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      duration: _withCtx(({ row }: { row: ClientInfo }) => [
        _createTextVNode(_toDisplayString(_unref(formatDuration)(row.duration * 60) || '--'), 1)
      ]),
      _: 1
    }, 8, ["table-opt", "modelValue", "has-permission"]),
    _createVNode(_component_el_dialog, {
      title: _ctx.$t('genuineSoftwareUsage.uninstallDialogTitle'),
      modelValue: data.uninstallDialogVisible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((data.uninstallDialogVisible) = $event)),
      width: "30%",
      "before-close": resetRadio,
      "destroy-on-close": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_6, [
          _createVNode(_component_el_button, {
            size: "small",
            type: "primary",
            onClick: uninstall
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.confirm')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_radio, {
          modelValue: data.uninstallType,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.uninstallType) = $event)),
          label: 0
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('genuineSoftwareUsage.uninstallTypeNotify')), 1)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_radio, {
          modelValue: data.uninstallType,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.uninstallType) = $event)),
          label: 1
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('genuineSoftwareUsage.uninstallTypeSilent')), 1)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ]))
}
}

})